import { useState, useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";

// CSS Import
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// PNG Import

// UTLIS Import
import {
  GeoMapLeafletIcon,
  locationDefault,
} from "../../../utils/configurationProvider.js";

// REDUX Import
import axiosInstance from "../../../redux/globalInspector/axiosInstance";

// LOADER Import
import Loader from "../../Loader/Index";
import ICONS from "../../../assets/Icons/index.js";

const defaultPosition = locationDefault.officeLocation;
// default Office Location
// const defaultPosition = [19.043690333072874, 72.8429991];

const ChangeView = ({ center }) => {
  const map = useMap();
  map.setView(center, map.getZoom());
  return null;
};

// const customIcon = L.icon({
//   iconUrl: loactionImg,
//   iconSize: [38, 38],
//   iconAnchor: [19, 38],
//   popupAnchor: [0, -38],
// });

const customIcon = L.icon({
  iconUrl: ICONS?.ADDRESS_MAP,
  iconSize: GeoMapLeafletIcon.iconSize,
  iconAnchor: GeoMapLeafletIcon.iconAnchor,
  popupAnchor: GeoMapLeafletIcon.popupAnchor,
});

const GeoMapLeaflet = (props) => {
  // useState
  const [position, setPosition] = useState(defaultPosition);
  const [loading, setLoading] = useState(true); // Loading state

  // useEffect
  useEffect(() => {
    const address = props.address;
    if (!address) return;

    const geocodeAddress = async () => {
      try {
        const response = await axiosInstance.get(
          "https://api.radar.io/v1/geocode/forward",
          {
            params: { query: address },
            headers: {
              Authorization:
                "prj_test_pk_a273c303ac12e9e092cc219f02503293fcb4e4e2",
            },
          },
        );

        const data = response.data;

        if (data.addresses && data.addresses.length > 0) {
          const { latitude, longitude } = data.addresses[0];
          setPosition([latitude, longitude]);
        } else {
          return { error: true, message: "No addresses found" };
        }
      } catch (error) {
        return { error: true, message: error?.response?.data || error.message };
      } finally {
        setLoading(false);
      }
    };

    if (address) {
      geocodeAddress(address).then((result) => {
        if (result?.error) {
          console.error("Geocode failed:", result.message);
        }
      });
    }
  }, [props.address]);

  return (
    <>
      {loading ? (
        <div
          className="w-full flex items-center justify-center "
          style={{
            height:
              props.owner === "ownerDetails"
                ? "var(--ownerDetails-popup-map-height)"
                : props.owner === "beneDetails"
                  ? "var(--max-height-top-slider)"
                  : props.owner === "gstDetails"
                    ? "var(--statistic-graph-height)"
                    : props.owner === "cin_details"
                      ? "256px"
                      : props.owner === "user_profile_din"
                        ? "var(--emp_card_height)"
                        : "var(--height-full)",
            width:
              props.owner === "ownerDetails"
                ? "var(--width-full)"
                : props.owner === "beneDetails"
                  ? "var(--beneDetails-popup-map-width)"
                  : props.owner === "gstDetails"
                    ? "var(--width-full)"
                    : props.owner === "user_profile_din"
                      ? "var(--width-section)"
                      : "var(--width-full)",
            borderRadius:
              props.owner === "user_profile_din" || props.owner === "gstDetails"
                ? "var(--border-radius-md)"
                : props.owner === "cin_details" ||
                    props.owner === "ownerDetails"
                  ? "var(--border-radius-md)"
                  : "",
          }}
        >
          <Loader />
        </div>
      ) : (
        <MapContainer
          center={position}
          zoom={13}
          style={{
            height:
              props.owner === "ownerDetails"
                ? "var(--ownerDetails-popup-map-height)"
                : props.owner === "beneDetails"
                  ? "var(--max-height-top-slider)"
                  : props.owner === "gstDetails"
                    ? "var(--statistic-graph-height)"
                    : props.owner === "cin_details"
                      ? "256px"
                      : props.owner === "user_profile_din"
                        ? "var(--emp_card_height)"
                        : "var(--height-full)",
            width:
              props.owner === "ownerDetails"
                ? "var(--width-full)"
                : props.owner === "beneDetails"
                  ? "var(--beneDetails-popup-map-width)"
                  : props.owner === "gstDetails"
                    ? "var(--width-full)"
                    : props.owner === "user_profile_din"
                      ? "var(--width-section)"
                      : "var(--width-full)",
            borderRadius:
              props.owner === "user_profile_din" || props.owner === "gstDetails"
                ? "var(--border-radius-md)"
                : props.owner === "cin_details" ||
                    props.owner === "ownerDetails"
                  ? "var(--border-radius-md)"
                  : "",
          }}
        >
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <Marker
            position={position}
            icon={customIcon}
          >
            <Popup>The custom icon is here!</Popup>
          </Marker>
          <ChangeView center={position} />
        </MapContainer>
      )}
    </>
  );
};

export default GeoMapLeaflet;
